angular.module('satv.playlist.pitch')
.controller('PitchLandingCtrl', ['$scope', '$rootScope', 'pitch', '$controller', '$timeout', 'Pitch', function ($scope, $rootScope, pitch, $controller, $timeout, Pitch) {
    'use strict';

    $scope.pitch = pitch;

    angular.extend(this, $controller('PlaylistLandingCtrl', {$scope: $scope, playlist: pitch.playlist}));

    $scope.downloadPlaylist = function(playlist) {
        $rootScope.$emit(
            'MEDIA_DOWNLOAD',
            $scope.playlistItemsLoader.data,
            { filename: pitch.playlist.name },
            { name: 'pitch', data: pitch.hash }
        );
    };

    /**
     * Refreshes the pitch in order to update the download/audition limit notifications.
     * We have a delay so as to not interfere with the start of playing.
     */
    function refreshPitch() {
        $timeout(function() {
            Pitch.get({ hash: pitch.hash }, function(r) {
                $scope.pitch = r;
            });
        }, 2000);
    }

    $rootScope.$on('MEDIA_PLAY', refreshPitch);
    //$rootScope.$on('MEDIA_DOWNLOAD', refreshPitch);
    $rootScope.$on('MEDIA_DOWNLOAD_READY', refreshPitch);

    //post a log entry back so that we can track how many times a pitch was viewed
    $timeout(function() {
        Pitch.log({ hash: pitch.hash });
    }, 2000);
}])
;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchLandingCtrl.js